export default {
    categories: {
        'service-price': {
            title: window.i18n.__('Services'),
            subtitle: window.i18n.__('Données service'),
        },
    },
    rows: [
        {
            category: 'service-price',
            label: window.i18n.__('Identifiant service'),
            description: {
                text: window.i18n.__('Récupéré depuis un export Sellsy'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Ce champ devient obligatoire s’il est utilisé en tant que critère de comparaison'),
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'service-price',
            label: window.i18n.__('Référence service'),
            description: {
                text: window.i18n.__('Référence ou code du service unique dans votre catalogue'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__('Ce champ devient obligatoire s’il est utilisé en tant que critère de comparaison'),
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
    ],
};
